import DateFnsUtils from "@date-io/date-fns";
import {
  Avatar,
  Fab,
  Grid,
  InputBase,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuList,
  Paper,
  Snackbar,
  SnackbarContent,
  Tooltip,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import Grow from "@material-ui/core/Grow";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import Popper from "@material-ui/core/Popper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import withWidth from "@material-ui/core/withWidth";
import { ErrorOutlined } from "@material-ui/icons";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import InboxOutlinedIcon from "@material-ui/icons/InboxOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import classNames from "classnames";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import socketIO from "socket.io-client";

import * as cookie from "../helper/cookie";
import { isCanLogout } from "../redux/authentication";
import datetimeHelper from "./../helper/datetime-helper";
import { globalHistory } from "./../history";
import { mapActionsToProps as actionAgent } from "./../redux/agent";
import { mapActionsToProps as ChannelAction } from "./../redux/cloudPBX/channel";
import { mapActionsToProps as extensionAction } from "./../redux/cloudPBX/extension";
import { mapActionsToProps as webrtcAction } from "./../redux/cloudPBX/webrtc";
import { mapActionsToProps as actionStatus } from "./../redux/contactCenter/agentStatus";
import { mapActionsToProps as articelAction } from "./../redux/miniCrm/article";
import { mapActionsToProps as topicAction } from "./../redux/miniCrm/topic";
import { mapActionsToProps as callLogsAction } from "./../redux/telesale/call";
import { mapActionsToProps } from "./../redux/user";
import Dialog from "./Dialog";
import DrawerExtension from "./DrawerExtension";
import TextValidatorPassword from "./input/TextValidatorPassword";
import KnowledgeBaseItem from "./KnowledgeBaseItem";
import LeftMenuItems from "./LeftMenuItems";
import ListNotification from "./ListNotification";
import Topic from "./SearchTopic";

const drawerWidth = 310;
const AGENT_CHAT_TICKET_URL = "/contact-center/agent-chat-ticket";
const styles = (theme) => {
  return {
    root: {
      flexGrow: 1,
      height: "100%",
      zIndex: 1,
      overflow: "hidden",
      position: "absolute",
      width: "100%",
      display: "flex",
      backgroundColor: "#015290",
    },
    kb: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // borderLeft: 'solid 1px #e0e0e054',
    },
    grow: {
      flexGrow: 1,
    },
    sectionDesktop: {
      display: "flex",
      paddingRight: 25,
      alignItems: "center",
    },
    menuButton: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit * 3,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 9,
        padding: theme.spacing.unit * 3,
      },
      float: "right",
    },
    hide: {
      display: "none",
    },
    drawerPaper: {
      position: "relative",
      // whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      backgroundColor: "#015290",
      color: "#fff",
    },
    drawerPaperRight: {
      width: 260,
    },
    drawerPaperClose: {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing.unit * 10,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing.unit * 18,
      },
      backgroundColor: "#015290",
      color: "#fff",
    },
    toolbar: {
      display: "flex",
      height: 48,
      alignItems: "center",
      justifyContent: "space-around",
      padding: "0 8px",
      backgroundColor: theme.palette.primary.main,
      // backgroundColor: "#f5f5f5",
      color: "white",
      ...theme.mixins.toolbar,
      [theme.breakpoints.down("sm")]: {
        height: theme.spacing.unit * 10,
      },
    },
    toolbarBottom: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      padding: "0 8px",
      // backgroundColor: "#f5f5f5",
      color: "white",
      ...theme.mixins.toolbar,
      [theme.breakpoints.down("xs")]: {
        paddingTop: theme.spacing.unit * 12,
      },
    },
    content: {
      flexGrow: 1,
      backgroundColor: "#f5f5f5",
      overflow: "auto",
      padding: theme.spacing.unit * 3,
      overflowY: "auto",
      paddingTop: 0,
      height: "100%",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing.unit * 2,
      },
    },
    main: {
      paddingTop: theme.spacing.unit * 3,
      height: "95%",
    },
    firstList: {
      padding: theme.spacing.unit * 2,
      [theme.breakpoints.down("sm")]: {
        padding: 0,
      },
    },
    logo: {
      height: 50,
      position: "relative",
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 50,
    },
    // selectBox: {
    //     color: '#fff'
    // },
    input: {
      marginTop: 18,
      width: 250,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
    },
    rootSearch: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
    inputSearch: {
      marginLeft: 8,
      flex: 1,
    },
    iconButtonSearch: {
      padding: 10,
    },
    dividerSearch: {
      width: 1,
      height: 28,
      margin: 4,
    },
    snackbar: {
      backgroundColor: "#fff",
      color: "#000",
    },
    snackbarReload: {
      color: "#fff",
      backgroundColor: "#ffa000",
    },
    row: {
      "&:nth-of-type(odd)": {
        backgroundColor: "rgba(237,239,120,.45)",
      },
    },
    listNoti: {
      height: "250px",
      overflowY: "scroll",
      overflowX: "unset",
      "&::-webkit-scrollbar": {
        width: "10px",
        backgroundColor: "#F5F5F5",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,.3)",
        backgroundColor: "#555",
      },
    },
    scrollContent: {
      height: "100%",
      overflowY: "scroll",
      overflowX: "unset",
      "&::-webkit-scrollbar": {
        width: "5px",
        backgroundColor: "#F5F5F5",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,.3)",
        backgroundColor: "#555",
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
    titleNoti: {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      padding: "10px",
      // color: 'white'
    },
    empty: {
      display: "flex",
      justifyContent: "center",
    },
    emptyIcon: {
      opacity: 0.5,
      height: "110px",
      width: "110px",
    },
    emptyText: {
      display: "flex",
      justifyContent: "center",
      opacity: 0.5,
      marginBottom: "5px",
    },
    boxEmpty: {
      padding: "30px",
    },
  };
};

class MiniDrawer extends React.Component {
  state = {
    openItemsLevel1: [],
    open: true,
    openSocketMessage: false,
    openLogoutMessage: false,
    isLoadingLogout: false,
    socketMessage: "",
    logoutMessage: "",
    extensionStatus: null,
    userAction: false,
    anchorEl: null,
    oldPassword: "",
    newPassword: "",
    modal: false,
    openStatus: null,
    showPassword: false,
    openDialpad: false,
    openMenuNotification: null,
    anchorElDialpad: null,
    top: false,
    user: this.props.user
      ? this.props.user.profile
        ? { ...this.props.user.profile.user }
        : null
      : null,
    callPhone: 0,
    timeTo: new Date().toJSON(),
    callFrom: "",
    callTo: "",
    callDuration: "",
    callType: "",
    callStatus: "",
    statusAnswer: null,
    showNotifi: false,
    extension: "",
    addNote: false,
    buttonAddNote: false,
    right: false,
    color: "",
    activeCallNoti: true,
    unload: false,
    optionView: false,
    openCollap: false,
    filters: {
      order: "createdAt DESC",
      where: {
        gte: null,
        lte: null,
      },
      page: 0,
      pageSize: 999,
    },
    submitTag: false,
    selectedItem: {},
    openTooltip: false,
    countSearchTopic: null,
    isShowCall: false,
    from: null,
  };

  async componentDidMount() {
    const { getArticleLog, getRecallLog } = this.props;
    const { filters } = this.state;

    const agentSocket = socketIO("https://socketio.api-connect.io/", {
      transports: ["websocket", "polling"],
      query: {
        user_id: cookie.getCookie("userId"),
        //access_token: cookie.getCookie("access_token"),
      },
    });

    agentSocket.on("vnpost-event-service", (socketResponse) => {
      if (socketResponse?.service_id === "extensionStatus") {
        const status = socketResponse?.data?.status === "online";
        this.setState({
          extensionStatus: status,
        });
      }
      if (socketResponse?.service_id === "changeAgentStatus") {
        this.setState({
          openSocketMessage: true,
          socketMessage: socketResponse?.data?.message || "",
        });
      }
    });

    agentSocket.on("connect", () => {
      console.log(`Connected Socket Id: `, agentSocket.id);
    });

    agentSocket.on("connect_error", function (err) {
      console.log("Connection Socket Failed. " + err.message);
    });

    // this.interval = setInterval(() => {
    //     getArticleLog(filters.order, filters.pageSize, null, null);
    //     // getRecallLog((!!this.props.agentStatus ? this.props.agentStatus.id : ''), this.state.timeTo)
    // }, 1000)

    // this.interval = setInterval(() => {
    //     if (window.location.pathname == `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`) {
    //         return (this.props.getRecallLog((!!this.props.agentStatus ? this.props.agentStatus.id : ''), this.state.timeTo))
    //     }
    //     // this.props.sessionWebrtc()
    //     this.setState({ session: this.props.callSession })
    // }, 1000);
    // this.props.getRecallLog(cookie.getCookie("agentId"), this.state.timeTo);

    this.history = globalHistory();
    await this.props.getInfo();
    // await this.props.user && this.props.getUser();
    await this.props.getStatusAgent();
    await this.props.getListAgentStatus(null, null, null, {
      where: { id: { neq: "stop" } },
    });
    this.props.getDataTree();
    // this.props.getListExtension("createdAt DESC", 99999);
    // this.props.getMixCall()
    // this.intervalGetMixCall = setInterval(() => {
    //     this.props.getMixCall()
    // }, 30000);

    setInterval(() => {
      this.props.getStatusAgent();
    }, 10000);
    // let socket = undefined
    // socket = socketIO(`https://socket.api-connect.io/`, {
    //     // transports: ["websocket"],
    //     query: {
    //         resource: "extension",
    //         extension: this.props.menu.agentStatus != undefined && this.props.menu.agentStatus.extension ? this.props.menu.agentStatus.extension.username : '',
    //         accessToken: this.props.menu.id,
    //     }
    // });
    // socket.on('connected', function (socket) {
    // })
    // socket.on('callStatusChanged', (call) => {
    //     // Trước đây việc lấy thông tin khách hàng được lấy qua socket này, nhưng do socket phản hồi chậm nên sẽ chuyển qua dùng API /cloud-pbx/active-call để lấy thông tin số điện thoại
    //     // Chỗ lấy ở trong file AgentUser.js và hàm gọi được thực thi trong componentDidUpdate() (this.props.getInfoCustomer(this.props.listActiveCall[0].from);)
    //
    //     // this.props.getInfoCustomer(call.from, call.variables['service-id'], call.variables['bussiness-id']);
    //     // this.props.getTicketByNumber({ phone: call.from }), // Chỗ lấy ở trong file AgentUser.js cũng chỗ với lấy ticket
    //     // this.props.getTodayMixCalls(call.from) // Chỗ lấy ở trong file AgentUser.js cũng chỗ với lấy ticket
    //     if (call) {
    //         if (call.type == "inbound") {
    //             switch (call.status) {
    //                 case "answer": {
    //                     return (
    //                         this.setState({ buttonAddNote: true, statusAnswer: call, showNotifi: !this.state.showNotifi })
    //                     )
    //                 }
    //                 case "hangup": {
    //                     return (
    //                         this.setState({ buttonAddNote: false, statusAnswer: null, showNotifi: false })
    //                     )
    //                 }
    //                 default: {
    //                     return (
    //                         this.setState({ statusAnswer: call, activeCallNoti: true, showNotifi: !this.state.showNotifi, phoneNumberCall: call.from })
    //                     )
    //                 }
    //             }
    //         }
    //     }
    // });

    if (this.props.menu.agentStatus != undefined) {
      if (this.props.menu.agentStatus.extensionId != "") {
        this.interval = setInterval(() => {
          this.props.getActiveCall({
            where: {
              "extension.id": { like: this.props.menu.agentStatus.extensionId },
            },
          });
        }, 1000);
      }
    }
    //window.addEventListener("unload", this.onUnload);
    //this.props.changeStatusAgent("stop")
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.listActiveCall.length &&
      state.from !== props?.listActiveCall[0]?.id
    ) {
      props.getInfoPhoneNumber(
        props?.listActiveCall[0]?.type === "inbound"
          ? props?.listActiveCall[0]?.from
          : props?.listActiveCall[0]?.to
      );
      return {
        ...state,
        from: props?.listActiveCall[0]?.id,
        note: "",
        addNote: false,
      };
    }
    if (props?.listActiveCall[0]?.status === "ringing") {
      return {
        ...state,
        note: "",
        addNote: false,
      };
    }
    return null;
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
    clearInterval(this.intervalGetMixCall);
    //window.removeEventListener("unload", this.onUnload);
  }

  // onUnload = e => {
  //     //window.event.returnValue = this.props.changeStatusAgent("stop");
  //     // return this.props.changeStatusAgent("service");
  // }

  handleOpenMenuLevel1 = (index) => {
    this.setState((state) => {
      const openItemsLevel1 = [...state.openItemsLevel1];
      openItemsLevel1[index] = !openItemsLevel1[index]; // Đảo ngược trạng thái mở của mục được nhấp vào
      return { openItemsLevel1 };
    });
  };

  handleDrawerOpen = () => {
    this.setState({
      open: false,
      userAction: true,
      openMenu: true,
    });
  };

  handleDrawerClose = () => {
    this.setState({
      open: true,
      userAction: true,
      openMenu: false,
    });
  };

  handleProfileMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      openStatus: null,
      openMenuNotification: null,
    });
  };

  handleLogout = async () => {
    try {
      this.setState({ isLoadingLogout: true });
      const canLogout = await isCanLogout();
      if (canLogout) {
        this.props.logout();
      } else {
        this.setState({ isLoadingLogout: false });
      }
    } catch (error) {
      this.setState({
        isLoadingLogout: false,
        openLogoutMessage: true,
        logoutMessage: `Không thể đăng xuất! ${
          error.message || "Có lỗi xảy ra!"
        }`,
      });
    }
  };

  handleChangePassword = () => {
    this.props.changePassword(this.state.oldPassword, this.state.newPassword);
    this.setState({ modal: false, oldPassword: "", newPassword: "" });
  };

  handleModalChanglePassword = () => {
    this.setState({ modal: true, oldPassword: "", newPassword: "" });
  };

  handleCloseModal = () => {
    this.setState({ modal: false });
  };

  handleChange = (name) => {
    return (e) => {
      const value = e.target.value;
      this.setState({
        [name]: value,
      });
    };
  };

  handleOpenMenuNotification = (event) => {
    this.setState({ openMenuNotification: event.currentTarget });
  };

  handleChangeProfile = () => {
    const { fullname, phoneNumber, address } = this.state.user;
    this.props.changeProfile(fullname, phoneNumber, address);
    setTimeout(
      function () {
        this.setState({ modalEditProfile: false });
      }.bind(this),
      500
    );
  };

  handleChangeUser = (name) => {
    return (e) => {
      this.setState({
        user: {
          ...this.state.user,
          [name]: e.target.value,
        },
      });
    };
  };

  handleOpenStatus = async (e) => {
    this.setState({ openStatus: e.currentTarget });
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  handleOpenArticle = async (articleId) => {
    await this.props.openAArticle(articleId);
    this.setState({ modalArticle: true });
  };

  handleSearchbhxh = () => {
    const { tags } = this.state;
    this.props.getRequestBHXH(tags);
    this.setState({ optionView: true });
  };

  handleAnswer = () => {
    if (this.props.modalCall) {
      this.setState({ session: this.props.callSession });
      this.props.answerCall();
    }
  };

  handleChangeExtension = (name) => {
    if (this.props.agentStatus !== undefined) {
      return (e) => {
        this.setState(
          {
            [name]: e,
            openTooltip: false,
          },
          () => {
            this.props.editAgent(
              this.props.agentStatus.id,
              this.state.extensionAgent?.id || ""
            );
          }
        );
      };
    }
  };

  handleCloseModalCall = () => {
    this.history.push(
      `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`
    );
    setTimeout(() => {
      this.setState({ statusAnswer: null });
    }, 500);
  };

  handleAddNote = () => {
    // console.log(this.state.statusAnswer, 'this.state.statusAnswer')
    // if (this.state.statusAnswer != null) {
    //     console.log(this.props.listActiveCall[0], 'hehehe')
    //     console.log(this.state.note, null, this.props.listActiveCall[0].cdrId, this.props.listActiveCall[0].type, this.props.listActiveCall[0].dialMode, 'hahahahah')
    return this.props.addNoteCall(
      this.state.note,
      null,
      this.props.listActiveCall[0].cdrId,
      this.props.listActiveCall[0].type,
      this.props.listActiveCall[0].dialMode
    );
    // }
  };

  handleReject = () => {
    if (this.props.listActiveCall.length !== 0) {
      return (
        this.props.getInfoCustomer(
          this.props.listActiveCall[0].from,
          this.props.listActiveCall[0].variables["service-id"],
          this.props.listActiveCall[0].variables["bussiness-id"]
        ),
        this.props.getTicketByNumber({
          phone: this.props.listActiveCall[0].from,
          source: { neq: "ott" },
        }),
        this.props.getTodayMixCalls(this.props.listActiveCall[0].from),
        this.history.push(
          `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`
        )
      );
    }
  };

  handleInfo = (item) => {
    if (item.type == "inbound") {
      this.props.getTodayMixCalls(item.numberFrom);
      this.props.getTicketByNumber({
        phone: item.numberFrom,
        source: { neq: "ott" },
      });
      this.props.getInfoCustomer(item.numberFrom);
      this.history.push(
        `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`
      );
    } else {
      this.props.getTodayMixCalls(item.numberTo);
      this.props.getTicketByNumber({
        phone: item.numberTo,
        source: { neq: "ott" },
      });
      this.props.getInfoCustomer(item.numberTo);
      this.history.push(
        `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`
      );
    }
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.props.getRequestBHXH(this.state.tags);
      this.setState({ optionView: true });
      e.preventDefault();
    }
  };

  preventDefault = (e) => {
    e.preventDefault();
  };

  handleSubmitTag = () => {
    this.setState(
      {
        openCollap: true,
        submitTag: true,
      },
      () => {
        // this.props.getDataTree({ keyword: this.state.keyword })
        this.props.searchArticle(this.state.keyword);
      }
    );
    setTimeout(() => {
      this.setState({
        countSearchTopic: Date.now(),
      });
    }, 1000);
  };

  handleSearchTag = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleCloseNotification = () => {
    this.setState({
      openMenuNotification: null,
    });
  };

  changeSubmitTag = () => {
    this.setState({
      submitTag: false,
    });
  };

  handleSelectedItem = (item) => {
    this.setState({ modalArticle: true, selectedItem: item });
  };

  handleTooltipOpen = () => {
    this.setState({ openTooltip: true });
  };

  handleTooltipClose = () => {
    this.setState({ openTooltip: false });
  };

  render() {
    const {
      classes,
      theme,
      width,
      agentStatus,
      info,
      listStatus,
      listKnowledgeBase,
      listInteractiveLogs,
      // listExtension,
      listTopic,
      contactBHXH,
      articles,
    } = this.props;
    const {
      open,
      userAction,
      anchorEl,
      oldPassword,
      newPassword,
      openStatus,
      openMenuNotification,
      note,
      tags,
      user,
      session,
    } = this.state;
    // fake menu
    // const info = {
    //   id: "cmc-voice-portal",
    //   name: "Voice Boost",
    //   description: "Voice Boost",

    //   menuItems: [
    //     {
    //       title: "Báo cáo - KPI",
    //       icon: "pie_chart",
    //       type: "",
    //       value: "",
    //       path: "",
    //       items: [
    //         {
    //           title: "Báo cáo cuộc gọi",
    //           type: "page",
    //           icon: "call",
    //           value: "agent",
    //           path: "",
    //           items: [
    //             {
    //               title: "Chi tiết cuộc gọi ra",
    //               type: "page",
    //               icon: "phone_forwarded",
    //               value: "detail-outbound-call",
    //               path: "/contact-center/report/detail-outbound-call",
    //             },
    //             {
    //               title: "Chi tiết cuộc gọi vào",
    //               type: "page",
    //               icon: "phone_callback",
    //               value: "detail-inbound-call",
    //               path: "/contact-center/report/detail-inbound-call",
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //     {
    //       title: "Báo cáo chat",
    //       icon: "tune",
    //       type: "",
    //       value: "",
    //       path: "",
    //       items: [
    //         {
    //           title: "Báo cáo lưu lượng chat",
    //           icon: "touch_app",
    //           type: "page",
    //           value: "interactive-log",
    //           path: "/report-chat",
    //         },
    //       ],
    //     },
    //   ],
    // };
    const isOpen = userAction ? !open : width == "xs";
    const isMenuOpen = Boolean(anchorEl);
    const isOpenMenuNotification = Boolean(openMenuNotification);
    const id = isOpenMenuNotification ? "simple-popover" : undefined;
    const pathname = this.props.location.pathname;
    const statusAgent = agentStatus ? agentStatus : {};
    let listStatusResult =
      typeof listStatus === "object"
        ? Object.keys(listStatus).map((key) => listStatus[key])
        : listStatus;
    listStatusResult.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    // thay đổi list status agent theo từng page
    if (pathname.includes("/contact-center/agent-dashboard")) {
      listStatusResult = listStatusResult.filter(
        (item) =>
          item.id === "service" || item.id === "pause" || item.id === "eating"
      );
    } else if (pathname.includes("/contact-center/agent-call-out")) {
      listStatusResult = listStatusResult.filter(
        (item) =>
          item.id === "manual" || item.id === "pause" || item.id === "eating"
      );
    } else if (pathname.includes("/live-chat")) {
      listStatusResult = listStatusResult.filter(
        (item) =>
          item.id === "omni" || item.id === "pause" || item.id === "eating"
      );
    }

    const listKnowledgeBaseResult =
      typeof listKnowledgeBase === "object"
        ? Object.keys(listKnowledgeBase).map((key) => listKnowledgeBase[key])
        : listKnowledgeBase;
    const listInteractiveLogsResult =
      typeof listInteractiveLogs === "object"
        ? Object.keys(listInteractiveLogs).map(
            (key) => listInteractiveLogs[key]
          )
        : listInteractiveLogs;
    const callDuration = session
      ? Math.floor((new Date() - session.startTime) / 1000)
      : "00:00:00";
    // const listExtensionResult =
    //   typeof listExtension === "object"
    //     ? Object.keys(listExtension).map((key) => listExtension[key])
    //     : listExtension;

    // const fakeData = [
    //     {
    //         open: false,
    //         variant: 'info',
    //         anchorOrigin: {
    //             vertical: 'bottom',
    //             horizontal: 'right'
    //         },
    //         message: {
    //             acountName: 'Hoàng',
    //             agentName: '1996',
    //             time: '12',
    //         }
    //     },
    //     {
    //         open: true,
    //         variant: 'info',
    //         anchorOrigin: {
    //             vertical: 'bottom',
    //             horizontal: 'right'
    //         },
    //         message: {
    //             acountName: 'Hoàng',
    //             agentName: '1996',
    //             time: '12',
    //         }
    //     },
    //     {
    //         open: true,
    //         variant: 'info',
    //         anchorOrigin: {
    //             vertical: 'bottom',
    //             horizontal: 'right'
    //         },
    //         message: {
    //             acountName: 'Hoàng',
    //             agentName: '1996',
    //             time: '12',
    //         }
    //     }];

    return (
      <div className={classes.root}>
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, isOpen && classes.appBarShift)}>
          <Toolbar disableGutters={!isOpen} style={{ color: "#ffffff" }}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(
                classes.menuButton,
                isOpen && classes.hide
              )}>
              <MenuIcon />
            </IconButton>
            {info
              ? info.menuItems &&
                info.menuItems.map((menu) => {
                  return menu.items.map((item, key) => {
                    let pathLevel1;
                    let pathLevel2;

                    if (item.items?.length > 0) {
                      return item.items.map((itemLevel2, keyLevel2) => {
                        pathLevel2 = `${process.env.REACT_APP_PATH}${itemLevel2.path}`;
                        if (pathLevel2 == pathname) {
                          return (
                            <Typography
                              style={{ textAlign: "center" }}
                              variant="h6"
                              color="inherit"
                              noWrap
                              key={keyLevel2}>
                              {itemLevel2.title}
                            </Typography>
                          );
                        }
                      });
                    }
                    pathLevel1 = `${process.env.REACT_APP_PATH}${item.path}`;
                    if (pathLevel1 == pathname) {
                      return (
                        <Typography
                          style={{ textAlign: "center" }}
                          variant="h6"
                          color="inherit"
                          noWrap
                          key={key}>
                          {item.title}
                        </Typography>
                      );
                    }
                  });
                })
              : null}
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <Tooltip
                title="Tra cứu thông tin bưu gửi"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  color="inherit"
                  onClick={this.toggleDrawer("top", true)}>
                  <Icon>search</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Tra cứu giá cước trong nước"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    const width = (window.screen.width * 70) / 100;
                    const height = (window.screen.height * 70) / 100;
                    const left = (window.screen.width * 15) / 100;
                    const top = (window.screen.height * 15) / 100;
                    window.open(
                      "http://www.vnpost.vn/vi-vn/tra-cuu-gia-cuoc",
                      "newWin",
                      "width=" +
                        width +
                        ",height=" +
                        height +
                        ",left=" +
                        left +
                        ",top=" +
                        top
                    );
                  }}>
                  <Icon>train</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Tra cứu giá cước quốc tế"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    const width = (window.screen.width * 70) / 100;
                    const height = (window.screen.height * 70) / 100;
                    const left = (window.screen.width * 15) / 100;
                    const top = (window.screen.height * 15) / 100;
                    window.open(
                      "http://ipostal.vnpost.vn/tra-cuu-gia-cuoc",
                      "newWin",
                      "width=" +
                        width +
                        ",height=" +
                        height +
                        ",left=" +
                        left +
                        ",top=" +
                        top
                    );
                  }}>
                  <Icon>flight</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Tra cứu tài liệu dịch vụ"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  color="inherit"
                  onClick={() => this.setState({ modalArticle: true })}>
                  <Icon>accessibility</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Thông báo thông tin tài liệu tra cứu được cập nhật và thông tin cần gọi lại"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  color="inherit"
                  onClick={this.handleOpenMenuNotification}>
                  <Badge
                  // badgeContent={!!listInteractiveLogsResult ? listInteractiveLogsResult.length : 0} color="secondary"
                  >
                    <Icon>notifications</Icon>
                    {articles &&
                      Array.isArray(articles) &&
                      articles.filter(
                        (article) => article.isNew && article.isPublished
                      ).length && (
                        <p
                          style={{
                            position: "absolute",
                            fontSize: 12,
                            top: -5,
                            left: 14,
                            color: "#ffffff",
                            backgroundColor: "#e74c3c",
                            width: 18,
                            height: 18,
                            borderRadius: "50%",
                          }}>
                          {
                            articles.filter(
                              (article) =>
                                article.isNew &&
                                article.isPublished &&
                                !article.isRead
                            ).length
                          }
                        </p>
                      )}
                  </Badge>
                </IconButton>
              </Tooltip>
              {listTopic ? (
                <Dialog
                  open={this.state.modalArticle}
                  onClose={() => this.setState({ modalArticle: false })}
                  title={"KnowledgeBase"}
                  maxWidth="xl"
                  fullScreen={true}
                  input={
                    <React.Fragment>
                      <AppBar
                        className={classes.appBar}
                        style={{ color: "#fff" }}>
                        <Toolbar>
                          <IconButton
                            color="inherit"
                            onClick={() => {
                              this.setState({
                                modalArticle: false,
                                selectedItem: {},
                                openCollap: false,
                                keyword: "",
                                submitTag: false,
                              });
                            }}
                            aria-label="Close">
                            <Icon>close</Icon>
                          </IconButton>
                          <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.flex}>
                            KnowledgeBase
                          </Typography>
                        </Toolbar>
                      </AppBar>
                      <Topic
                        countSearchTopic={this.state.countSearchTopic}
                        changeSelectedItem={(item) =>
                          this.setState({ selectedItem: item })
                        }
                        selectedItem={this.state.selectedItem}
                        treeData={listTopic}
                        submitTag={this.state.submitTag}
                        changeSubmitTag={this.changeSubmitTag}
                        openSearch={this.state.openCollap}
                        listSearchArticle={this.props.listSearchArticle}
                        search={
                          <ValidatorForm
                            ref="form"
                            onSubmit={this.handleSubmitTag}
                            onError={(errors) => console.log(errors)}
                            className={classes.form}>
                            <Grid
                              container
                              style={{
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "flex",
                              }}>
                              <Grid item md={8}>
                                <TextValidator
                                  id="outlined-full-width"
                                  margin="normal"
                                  label="Tìm kiếm bài viết"
                                  variant="outlined"
                                  className={classes.input}
                                  onChange={this.handleSearchTag("keyword")}
                                  value={this.state.keyword}
                                  name="keyword"
                                  required
                                  validators={["matchRegexp:^.{3,}$"]}
                                  errorMessages={["Tối thiểu 3 kí tự"]}
                                />
                              </Grid>
                              <Grid
                                item
                                md={3}
                                style={{ marginLeft: 5, display: "flex" }}>
                                <Tooltip title="Tìm kiếm" disableFocusListener>
                                  <Fab
                                    color="primary"
                                    aria-label="Search"
                                    size="small"
                                    className={classes.fab}
                                    type="submit">
                                    <Icon>search</Icon>
                                  </Fab>
                                </Tooltip>
                                <Tooltip
                                  title="Tải lại danh sách"
                                  disableFocusListener>
                                  <Fab
                                    color="primary"
                                    aria-label="Search"
                                    size="small"
                                    className={classes.fab}
                                    onClick={() =>
                                      this.setState({
                                        keyword: "",
                                        openCollap: false,
                                        submitTag: false,
                                        selectedItem: {},
                                      })
                                    }>
                                    <Icon>cached</Icon>
                                  </Fab>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </ValidatorForm>
                        }
                      />
                    </React.Fragment>
                  }
                />
              ) : null}
              <Popover
                id={id}
                open={isOpenMenuNotification}
                anchorEl={openMenuNotification}
                onClose={this.handleCloseNotification}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}>
                {
                  <div className={classes.listNoti}>
                    <div className={classes.titleNoti}>
                      <Typography
                        component="span"
                        className={classes.inline}
                        color="textPrimary">
                        Thông tin bài viết
                      </Typography>
                    </div>
                    <div
                      className={
                        articles && articles.length > 1
                          ? classes.scrollContent
                          : ""
                      }>
                      {articles &&
                      articles.length &&
                      articles.filter(
                        (article) => article.isNew && article.isPublished
                      ).length ? (
                        articles.map((item, index) => {
                          return item.isNew && item.isPublished ? (
                            <ListNotification
                              onSelectedItem={this.handleSelectedItem}
                              index={index}
                              isRead={item.isRead}
                              item={item}
                              icon={"content_copy"}
                              subContent={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    className={classes.inline}
                                    color="textPrimary">
                                    Thời gian tạo:{" "}
                                    {datetimeHelper.toFormat(
                                      item.createdAt,
                                      "YYYY-MM-DD HH:mm:ss"
                                    )}
                                  </Typography>
                                </React.Fragment>
                              }
                            />
                          ) : null;
                        })
                      ) : (
                        <div className={classes.boxEmpty}>
                          <div className={classes.empty}>
                            <InboxOutlinedIcon className={classes.emptyIcon} />
                          </div>
                          <div className={classes.emptyText}>
                            <Typography
                              component="span"
                              className={classes.inline}
                              color="textPrimary">
                              Chưa có thông tin
                            </Typography>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={classes.titleNoti}>
                      <Typography
                        component="span"
                        className={classes.inline}
                        color="textPrimary">
                        Thông tin gọi lại
                      </Typography>
                    </div>
                    <div
                      className={
                        listInteractiveLogsResult &&
                        listInteractiveLogsResult.length > 1
                          ? classes.scrollContent
                          : ""
                      }>
                      {listInteractiveLogsResult &&
                      listInteractiveLogsResult.length > 0 ? (
                        listInteractiveLogsResult.map((item, index) => {
                          return (
                            <ListNotification
                              index={index}
                              item={item}
                              icon={"person"}
                              key={index}
                              subConten={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    className={classes.inline}
                                    color="textPrimary">
                                    Số điện thoại: {item.to}
                                  </Typography>
                                  <Typography
                                    component="span"
                                    className={classes.inline}
                                    color="textPrimary">
                                    Thời gian gọi lại:{" "}
                                    {datetimeHelper.toFormat(
                                      item.recallTime,
                                      "YYYY-MM-DD HH:mm:ss"
                                    )}
                                  </Typography>
                                </React.Fragment>
                              }
                            />
                          );
                        })
                      ) : (
                        <div className={classes.boxEmpty}>
                          <div className={classes.empty}>
                            <InboxOutlinedIcon className={classes.emptyIcon} />
                          </div>
                          <div className={classes.emptyText}>
                            <Typography
                              component="span"
                              className={classes.inline}
                              color="textPrimary">
                              Chưa có thông tin
                            </Typography>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                }
              </Popover>
              {/* {
                                !!statusAgent.extension ? (
                                    statusAgent.extension.webrtc ? (
                                        <React.Fragment>
                                            <IconButton variant="contained" className={classes.button} onClick={() => this.setState({ openDialpad: !this.state.openDialpad })}>
                                                <Icon>dialpad</Icon>
                                            </IconButton>
                                            <WebRTC
                                                open={this.state.openDialpad}
                                                onClose={() => this.setState({ openDialpad: false })}
                                                userId={!!statusAgent.extension ? statusAgent.extension.username : ''}
                                                password={!!statusAgent.extension ? statusAgent.extension.password : ''}
                                                hostname={!!statusAgent.extension ? statusAgent.extension.webrtc ? statusAgent.extension.webrtc.host : '' : ''}
                                                port={!!statusAgent.extension ? statusAgent.extension.webrtc ? statusAgent.extension.webrtc.port : '' : ''}
                                                path={!!statusAgent.extension ? statusAgent.extension.webrtc ? statusAgent.extension.webrtc.path : '' : ''}
                                                // phone={this.state.callPhone}
                                                autoAnswer={!!statusAgent.status ? statusAgent.status.attributes.autoCall : false}
                                            />
                                            {
                                                !!this.props.modalCall ? (
                                                    <Snackbar
                                                        open={this.props.modalCall}
                                                        anchorOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                        onClose={this.handleClose}
                                                    >
                                                        <SnackbarContent
                                                            className={classes.snackbar}
                                                            message={
                                                                <React.Fragment>
                                                                    <Typography variant="body2" style={{ color: "#000" }} gutterBottom>Họ tên: {session != null ? !!session.request ? session.request.from.displayName : '' : ''}</Typography>
                                                                    <Typography variant="body2" style={{ color: "#000" }} gutterBottom>Số điện thoại: {session != null ? !!session.remoteIdentity ? session.remoteIdentity.uri.normal.user : '' : ''}</Typography>
                                                                    <Typography variant="body2" style={{ color: "#000" }} gutterBottom> Thời lượng: {callDuration ? datetimeHelper.secondToHHMMSS(callDuration) : `00:00:00`}</Typography>
                                                                    <Typography variant="body2" style={{ color: "#000" }} gutterBottom> Trạng thái: {session != null ? session.type == "outbound" ? 'Đang gọi ra' : 'Đang gọi đến' : ''}</Typography>
                                                                    {
                                                                        this.state.checkAnswer == true ? (
                                                                            <Grid container>
                                                                                <Grid item md={6}>
                                                                                    <Tooltip title="Chuyển tiếp cuộc gọi" aria-label="Chuyển tiếp cuộc gọi">
                                                                                        <IconButton variant="contained" color="primary" style={{ marginRight: 10 }} className={classes.button} onClick={() => this.setState({ modalTranfer: true })}>
                                                                                            <Icon>call_split</Icon>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </Grid>
                                                                                <Grid item md={6}>
                                                                                    <Tooltip title="Lưu thông tin khách hàng" aria-label="Lưu thông tin khách hàng">
                                                                                        <IconButton variant="contained" color="primary" style={{ marginRight: 10 }} className={classes.button} onClick={() => this.setState({ modalSave: true })}>
                                                                                            <Icon>save</Icon>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </Grid>
                                                                            </Grid>
                                                                        ) : null
                                                                    }
                                                                </React.Fragment>
                                                            }
                                                            action={
                                                                <React.Fragment>
                                                                    {
                                                                        this.state.checkAnswer != true ? (
                                                                            <Button variant="contained" style={{ backgroundColor: 'green', color: '#fff', marginRight: 10 }} className={classes.button} onClick={this.handleAnswer}>
                                                                                <Icon>call</Icon>
                                                                            </Button>
                                                                        ) : null
                                                                    }
                                                                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => this.props.endCall()}>
                                                                        <Icon>call_end</Icon>
                                                                    </Button>
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </Snackbar>
                                                ) : null
                                            }
                                        </React.Fragment>

                                    ) : null
                                ) : null
                            } */}

              {this.props.agentStatus?.id && (
                <DrawerExtension
                  label={"Máy lẻ"}
                  getOptionLabel={(item) => {
                    return item && (item.name || item.username)
                      ? `${item.name} - ${item.username}`
                      : "";
                  }}
                  getSearchValues={(inputString) => {
                    if (inputString.includes("-")) {
                      const name = inputString.split("-")[0].trim();
                      const username = inputString.split("-")[1]?.trim() || "";
                      return {
                        or: [
                          { name: { like: name } },
                          { username: { like: username } },
                        ],
                      };
                    }
                    return {
                      or: [
                        { name: { like: inputString.trim() } },
                        { username: { like: inputString.trim() } },
                      ],
                    };
                  }}
                  value={
                    statusAgent.extensionId
                      ? {
                          id: statusAgent.extensionId,
                          name: statusAgent.extension?.name || "",
                          username: statusAgent.extension?.username || "",
                        }
                      : null
                  }
                  agentId={this.props.agentStatus?.id}
                  extensionStatus={this.state.extensionStatus}
                />
              )}

              {statusAgent.attributes ? (
                statusAgent.attributes.allowChangeExtension === true ? (
                  <></>
                ) : (
                  <React.Fragment />
                )
              ) : (
                <React.Fragment />
              )}
              {!!statusAgent.status && (
                <React.Fragment>
                  <Tooltip
                    title="Chọn trạng thái điện thoại viên"
                    placement="bottom"
                    disableFocusListener={true}>
                    <IconButton
                      variant="contained"
                      className={classes.button}
                      onClick={this.handleOpenStatus}>
                      <Icon
                        className={classes.rightIcon}
                        style={{ color: `${statusAgent.status.color}` }}>
                        {statusAgent.status.icon}
                      </Icon>
                    </IconButton>
                  </Tooltip>
                </React.Fragment>
              )}
              <Popper
                open={Boolean(openStatus)}
                anchorEl={openStatus}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    id="menu-list-grow"
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}>
                    <Paper>
                      <ClickAwayListener onClickAway={this.handleMenuClose}>
                        <MenuList>
                          {listStatusResult
                            ? listStatusResult.map((item, key) => {
                                return (
                                  <MenuItem
                                    value={item.id}
                                    key={key}
                                    onClick={() => {
                                      this.props.changeStatusAgent(item.id);
                                      this.setState({ openStatus: null });
                                    }}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>

              {/* <Menu
                                anchorEl={openStatus}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={Boolean(openStatus)}
                                onClose={this.handleMenuClose}
                            >

                            </Menu> */}
              <Tooltip
                title="Thông tin tài khoản"
                placement="bottom"
                disableFocusListener={true}>
                <IconButton
                  aria-owns={"material-appbar"}
                  aria-haspopup="true"
                  onClick={this.handleProfileMenuOpen}
                  color="inherit">
                  <AccountCircle />
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMenuOpen}
            onClose={this.handleMenuClose}>
            {info !== undefined ? (
              info.attributes !== undefined ? (
                info.attributes.role === "telephonist.service" ? (
                  <MenuItem disabled>Điện thoại viên</MenuItem>
                ) : info.attributes.role === "ITAdministrator" ? (
                  <MenuItem disabled>Quản trị IT</MenuItem>
                ) : info.attributes.role === "Supervisor" ? (
                  <MenuItem disabled>Giám sát</MenuItem>
                ) : info.attributes.role === "Leader" ? (
                  <MenuItem disabled>Lãnh đạo</MenuItem>
                ) : (
                  <MenuItem disabled>Quản lý</MenuItem>
                )
              ) : (
                <React.Fragment />
              )
            ) : (
              <React.Fragment />
            )}
            {statusAgent.id != "" ? (
              <React.Fragment>
                <MenuItem>
                  <Icon className={classes.leftIcon}>assignment_ind</Icon>{" "}
                  {statusAgent.code}
                </MenuItem>
                {statusAgent.extension ? (
                  <MenuItem>
                    <Icon className={classes.leftIcon}>phone</Icon>
                    {statusAgent.extension.name} -{" "}
                    {statusAgent.extension.username}
                  </MenuItem>
                ) : null}
                {statusAgent.group ? (
                  <MenuItem>
                    <Icon className={classes.leftIcon}>people</Icon>
                    {statusAgent.group.name}
                  </MenuItem>
                ) : null}
                {statusAgent.status ? (
                  // Trên production sẽ tồn tại 2 giao diện làm việc để backup cho khách hàng
                  <>
                    <MenuItem
                      onClick={() => {
                        this.history.push(
                          `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`
                        );
                        this.setState({ isShowCall: false });
                      }}>
                      <Icon className={classes.leftIcon}>devices</Icon>Giao diện
                      làm việc
                    </MenuItem>
                  </>
                ) : null}

                <Divider />
              </React.Fragment>
            ) : (
              <React.Fragment />
            )}
            <MenuItem onClick={() => this.setState({ modalEditProfile: true })}>
              <Icon className={classes.leftIcon}>person</Icon>Thông tin cá nhân
            </MenuItem>
            <MenuItem onClick={this.handleModalChanglePassword}>
              <Icon className={classes.leftIcon}>vpn_key</Icon>Đổi mật khẩu
            </MenuItem>
            <MenuItem onClick={this.handleLogout}>
              <div style={{ float: "left", width: "100%" }}>
                <Icon className={classes.leftIcon}>power_settings_new</Icon>Đăng
                xuất
              </div>{" "}
              {this.state.isLoadingLogout && (
                <div style={{ float: "right" }}>
                  <CircularProgress style={{ width: 20, height: 20 }} />
                </div>
              )}
            </MenuItem>
          </Menu>
          {/* <Linear /> */}
        </AppBar>

        <Dialog
          title="Thay đổi thông tin cá nhân"
          open={this.state.modalEditProfile}
          onClose={() => this.setState({ modalEditProfile: false })}
          input={
            // <div className={classes.modal}>
            <ValidatorForm
              ref="form"
              onSubmit={this.handleChangeProfile}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Username"
                  value={user ? user.username : null}
                  disabled
                />
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Email"
                  value={user ? user.email : null}
                  disabled
                />
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Họ tên"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onChange={this.handleChangeUser("fullname")}
                  value={user ? user.fullname : null}
                  name="fullname"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Số điện thoại"
                  variant="outlined"
                  type="number"
                  style={{ width: "100%" }}
                  onChange={this.handleChangeUser("phoneNumber")}
                  value={user ? user.phoneNumber : null}
                  name="phoneNumber"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Địa chỉ"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onChange={this.handleChangeUser("address")}
                  value={user ? user.address : null}
                  name="address"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
              </FormControl>
              <DialogActions>
                <Button
                  color="secondary"
                  size="small"
                  onClick={() => this.setState({ modalEditProfile: false })}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  size="small">
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
            // </div>
          }
        />
        <Dialog
          title="Thay đổi mật khẩu"
          open={this.state.modal}
          onClose={() => this.setState({ modal: false })}
          input={
            <div className={classes.modal}>
              <ValidatorForm
                ref="form"
                onSubmit={this.handleChangePassword}
                onError={(errors) => console.log(errors)}>
                <FormControl>
                  <TextValidatorPassword
                    placeholder="Mật khẩu cũ"
                    value={oldPassword}
                    className={classes.input}
                    onChange={this.handleChange("oldPassword")}
                    name="oldPassword"
                    strongValidate={false}
                    required
                  />

                  <TextValidatorPassword
                    placeholder="Mật khẩu mới"
                    value={newPassword}
                    className={classes.input}
                    onChange={this.handleChange("newPassword")}
                    name="newPassword"
                    required
                  />
                </FormControl>
                <DialogActions>
                  <Button
                    color="secondary"
                    size="small"
                    onClick={this.handleCloseModal}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    size="small">
                    Lưu
                  </Button>
                </DialogActions>
              </ValidatorForm>
            </div>
          }
        />
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !isOpen && classes.drawerPaperClose
            ),
          }}
          open={isOpen}>
          <div className={classes.toolbar}>
            {/* <img src={logo} className={classes.logo} /> */}
            <Typography
              style={{ textAlign: "center" }}
              variant="h6"
              color="inherit"
              noWrap>
              {info ? info.name : ""}
            </Typography>
            <IconButton onClick={this.handleDrawerClose} color="inherit">
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List className={classes.firstList} component="nav">
            {!statusAgent.status && (
              <Tooltip title={"Dashboard"} placement="right">
                <ListItem
                  disableTouchRipple
                  button
                  selected={
                    this.props.location.pathname ===
                    `${process.env.REACT_APP_PATH}`
                  }
                  onClick={() => {
                    this.history.push(`${process.env.REACT_APP_PATH}`);
                  }}
                  style={
                    this.props.location.pathname ===
                    `${process.env.REACT_APP_PATH}`
                      ? { boxShadow: "inset 0.1875rem 0 0 #fcb71e" }
                      : { boxShadow: "none" }
                  }>
                  <ListItemIcon>
                    <Icon style={{ color: "#fff" }}>dashboard</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" className="title" />
                </ListItem>
              </Tooltip>
            )}

            {info
              ? info.menuItems &&
                info.menuItems.map((menu, key) => {
                  return (
                    <React.Fragment key={key}>
                      <LeftMenuItems
                        title={menu.title}
                        subItems={menu.items}
                        item={menu}
                        iconString={menu.icon}
                        handleOpenMenu={this.handleDrawerOpen}
                        handleOpenMenuLevel1={this.handleOpenMenuLevel1}
                        id={key}
                        openMenuLevel1={
                          (this.state.openItemsLevel1[key] &&
                            this.state.openMenu) ||
                          false
                        }
                      />
                      <Divider />
                    </React.Fragment>
                  );
                })
              : null}
            {(this.props.menu?.profile?.user?.role === "telephonist.service" ||
              this.props.menu?.profile?.user?.role === "Supervisor") && (
              <>
                <Tooltip title={"Danh sách chat"} placement="right">
                  <ListItem
                    disableTouchRipple
                    button
                    selected={
                      this.props.location.pathname ===
                      `${process.env.REACT_APP_PATH}${AGENT_CHAT_TICKET_URL}`
                    }
                    onClick={() =>
                      (window.location.href = `${process.env.REACT_APP_PATH}${AGENT_CHAT_TICKET_URL}`)
                    }
                    style={
                      this.props.location.pathname ===
                      `${process.env.REACT_APP_PATH}${AGENT_CHAT_TICKET_URL}`
                        ? { boxShadow: "inset 0.1875rem 0 0 #fcb71e" }
                        : { boxShadow: "none" }
                    }>
                    <ListItemIcon>
                      <Icon style={{ color: "#fff" }}>chat</Icon>
                    </ListItemIcon>
                    {/* TODO ẩn khi chưa đồng bộ bên goteck */}
                    <ListItemText
                      primary="Danh sách chat"
                      className="title"
                      style={{ whiteSpace: "nowrap", color: "#fff" }}
                    />
                  </ListItem>
                </Tooltip>
                <Divider />
              </>
            )}
          </List>
        </Drawer>
        <main className={classes.content} onClick={this.handleDrawerClose}>
          <div className={classes.toolbarBottom} />
          <div className={classes.main}>
            {this.props.children}
            <Drawer
              anchor="top"
              open={this.state.top}
              onClose={this.toggleDrawer("top", false)}>
              <div
                tabIndex={0}
                role="button"
                // onClick={this.toggleDrawer('top', false)}
                // onKeyDown={this.toggleDrawer('top', false)}
              >
                <List
                  component="nav"
                  subheader={
                    <React.Fragment>
                      <Paper className={classes.rootSearch} elevation={1}>
                        <InputBase
                          className={classes.inputSearch}
                          placeholder="Tra cứu thông tin bưu gửi"
                          onChange={this.handleChange("tags")}
                          value={tags}
                          name="tags"
                          onKeyDown={this.keyPress}
                        />
                        <IconButton
                          className={classes.iconButtonSearch}
                          aria-label="Search"
                          onClick={this.handleSearchbhxh}>
                          <Icon>search</Icon>
                        </IconButton>
                      </Paper>
                    </React.Fragment>
                  }
                  className={classes.kb}>
                  <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                  {listKnowledgeBaseResult
                    ? listKnowledgeBaseResult.map((item, key) => {
                        return (
                          <KnowledgeBaseItem
                            key={key}
                            title={item.title}
                            subItems={item.topics}
                            item={item}
                            iconString={item.icon}
                            handleOpenArticle={this.handleOpenArticle}
                          />
                        );
                      })
                    : null}
                </List>
              </div>
            </Drawer>
            <Drawer
              anchor="right"
              open={this.state.right}
              onClose={this.toggleDrawer("right", false)}
              classes={{
                paper: classNames(classes.drawerPaperRight),
              }}
              // variant="persistent"
            >
              <div
                tabIndex={0}
                role="button"
                // onClick={this.toggleDrawer('top', false)}
                // onKeyDown={this.toggleDrawer('top', false)}
              >
                <List component="nav">
                  {this.props.callInfo && this.props.callInfo.length != 0 ? (
                    this.props.callInfo.map((item, key) => {
                      return (
                        <React.Fragment key={key}>
                          <ListItem
                            button
                            onClick={() => this.handleInfo(item, key)}
                            style={{
                              boxShadow:
                                this.props.callInfo.indexOf(item) == key
                                  ? "inset 0.1875rem 0 0 #fcb71e"
                                  : "none",
                            }}>
                            <Avatar>
                              <Fab
                                aria-label="Call"
                                style={{
                                  backgroundColor: "#43a047",
                                  color: "#fff",
                                }}>
                                {item.type == "inbound" ? (
                                  <Icon>phone_callback</Icon>
                                ) : (
                                  <Icon>phone_forwarded</Icon>
                                )}
                              </Fab>
                            </Avatar>
                            <ListItemText
                              primary={item.numberFrom}
                              secondary={`${datetimeHelper.toFormat(
                                item.startedAt,
                                "YYYY-MM-DD HH:mm:ss"
                              )}`}
                            />
                          </ListItem>
                          <Divider />
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <Typography
                      className={classes.typo}
                      style={{ textAlign: "center" }}>
                      Not Found!
                    </Typography>
                  )}
                </List>
              </div>
            </Drawer>
          </div>
          <Dialog
            open={this.state.optionView}
            onClose={() => this.setState({ optionView: false })}
            // title="Tra cứu BHXH"
            maxWidth="xl"
            input={
              <ValidatorForm
                ref="form"
                onSubmit={() => {}}
                onError={(errors) => console.log(errors)}
                className={classes.form}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Divider />
                  <Grid container>
                    <Grid item md={6} style={{ paddingRight: 10 }}>
                      <Typography
                        style={{
                          fontWeight: "bold",
                          margin: "10px 0",
                          color: "red",
                        }}>
                        Thông tin bưu gửi
                      </Typography>
                      <div
                        style={{
                          fontFamily: "Arial,sans-serif",
                          fontSize: "13px",
                        }}>
                        <div>
                          <b>Mã hồ sơ:</b>{" "}
                          <Link
                            style={{ color: "red" }}
                            onClick={() =>
                              window.open(
                                `http://www.vnpost.vn/vi-vn/dinh-vi/buu-pham?key=${
                                  contactBHXH.data
                                    ? contactBHXH.data.RequestItem.ItemCode
                                    : ""
                                }`,
                                "_blank"
                              )
                            }>
                            {contactBHXH.data
                              ? contactBHXH.data.RequestItem !== null
                                ? contactBHXH.data.RequestItem.ItemCode
                                : ""
                              : ""}
                          </Link>
                        </div>
                        <br />
                        <div>
                          <b>Người liên hệ:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_nguoilienhe
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Địa chỉ:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem.DoanhNghiep_diachi
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Điện thoại:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_dienthoai
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Email:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem
                              ? contactBHXH.data.RequestItem.DoanhNghiep_Email
                              : ""
                            : ""}
                        </div>
                        <br />
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      style={{ paddingLeft: 10, marginTop: 40 }}>
                      <div
                        style={{
                          fontFamily: "Arial,sans-serif",
                          fontSize: "13px",
                        }}>
                        <div>
                          <b>Người nhận:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_Ten_NguoiNhan
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Địa chỉ người nhận:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_Diachi_NguoiNhan
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Điện thoại người nhận:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_Dienthoai_NguoiNhan
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Email người nhận:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_Email_NguoiNhan
                              : ""
                            : ""}
                        </div>
                        <br />
                        <div>
                          <b>Ghi chú:</b>{" "}
                          {contactBHXH.data
                            ? contactBHXH.data.RequestItem !== null
                              ? contactBHXH.data.RequestItem
                                  .DoanhNghiep_GhiChu_NguoiNhan
                              : ""
                            : ""}
                        </div>
                        <br />
                      </div>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Typography
                    style={{
                      fontWeight: "bold",
                      margin: "10px 0",
                      color: "red",
                    }}>
                    Thông tin trạng thái bưu gửi chiều đi
                  </Typography>
                  <Grid container>
                    <Table className={classes.table}>
                      <TableHead
                        style={{
                          backgroundColor: "#02C5DE",
                          color: "#fff",
                          padding: "8px 8px",
                          fontSize: "12px",
                          borderBottom: 0,
                          borderRight: "1px solid #fff",
                        }}>
                        <TableRow>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <Link
                              style={{ color: "red" }}
                              onClick={() =>
                                window.open(
                                  `http://www.vnpost.vn/vi-vn/dinh-vi/buu-pham?key=${
                                    contactBHXH.data
                                      ? contactBHXH.data.RequestItem.ItemCode
                                      : ""
                                  }`,
                                  "Data",
                                  "height=600,width=800"
                                )
                              }>
                              Tra cứu hành trình Vnpost.vn: Bưu gửi{" "}
                              {contactBHXH.data
                                ? contactBHXH.data.RequestItem !== null
                                  ? contactBHXH.data.RequestItem.ItemCode
                                  : ""
                                : ""}
                            </Link>
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <b style={{ color: "#fff" }}>Chiều nộp hồ sơ:</b>{" "}
                            Chiều đi
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contactBHXH.data
                          ? contactBHXH.data.TraceItem !== null
                            ? contactBHXH.data.TraceItem.map((item, key) => {
                                return (
                                  <TableRow
                                    key={key}
                                    style={{
                                      backgroundColor: "#ade9ff",
                                    }}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      {item.StatusId}
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      {item.RequestStatus}
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      {datetimeHelper.toFormat(
                                        item.SendingTime,
                                        "YYYY-MM-DD"
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            : ""
                          : ""}
                      </TableBody>
                    </Table>
                  </Grid>
                  <Divider />
                  <Typography
                    style={{
                      fontWeight: "bold",
                      margin: "10px 0",
                      color: "red",
                    }}>
                    Thông tin trạng thái bưu gửi chiều về
                  </Typography>
                  <Grid container>
                    <Table className={classes.table}>
                      <TableHead
                        style={{
                          backgroundColor: "#02C5DE",
                          color: "#fff",
                          padding: "8px 8px",
                          fontSize: "12px",
                          borderBottom: 0,
                          borderRight: "1px solid #fff",
                        }}>
                        <TableRow>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <Link
                              style={{ color: "red" }}
                              onClick={() =>
                                window.open(
                                  `http://www.vnpost.vn/vi-vn/dinh-vi/buu-pham?key=${
                                    contactBHXH.data_chieuve
                                      ? contactBHXH.data_chieuve.RequestItem
                                          .ItemCode
                                      : ""
                                  }`,
                                  "Data",
                                  "height=600,width=800"
                                )
                              }>
                              Tra cứu hành trình Vnpost.vn: Bưu gửi{" "}
                              {contactBHXH.data_chieuve
                                ? contactBHXH.data_chieuve.RequestItem !== null
                                  ? contactBHXH.data_chieuve.RequestItem
                                      .ItemCode
                                  : ""
                                : ""}
                            </Link>
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <b style={{ color: "#fff" }}>Chiều nộp hồ sơ:</b>{" "}
                            Chiều về
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contactBHXH.data_chieuve
                          ? contactBHXH.data_chieuve.TraceItem !== null
                            ? contactBHXH.data_chieuve.TraceItem.map(
                                (item, key) => {
                                  return (
                                    <TableRow
                                      key={key}
                                      style={{
                                        backgroundColor: "#ade9ff",
                                      }}>
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        style={{
                                          borderRight:
                                            "1px solid rgba(224, 224, 224, 1)",
                                          paddingRight: "14px",
                                        }}>
                                        {item.StatusId}
                                      </TableCell>
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        style={{
                                          borderRight:
                                            "1px solid rgba(224, 224, 224, 1)",
                                          paddingRight: "14px",
                                        }}>
                                        {item.RequestStatus}
                                      </TableCell>
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        style={{
                                          borderRight:
                                            "1px solid rgba(224, 224, 224, 1)",
                                          paddingRight: "14px",
                                        }}>
                                        {datetimeHelper.toFormat(
                                          item.SendingTime,
                                          "YYYY-MM-DD"
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )
                            : ""
                          : ""}
                      </TableBody>
                    </Table>
                  </Grid>
                  <Divider />
                  <Typography
                    style={{
                      fontWeight: "bold",
                      margin: "10px 0",
                      color: "red",
                    }}>
                    Thông tin Hồ Sơ
                  </Typography>
                  <Grid container>
                    <Table className={classes.table}>
                      <TableHead
                        style={{
                          backgroundColor: "#02C5DE",
                          color: "#fff",
                          padding: "8px 8px",
                          fontSize: "12px",
                          borderBottom: 0,
                          borderRight: "1px solid #fff",
                        }}>
                        <TableRow>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <p style={{ color: "#fff" }}>Mã Hồ Sơ</p>
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <p style={{ color: "#fff" }}>Thông tin hồ sơ</p>
                          </TableCell>
                          <TableCell
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            <p style={{ color: "#fff" }}>Ngày tạo</p>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contactBHXH.data
                          ? contactBHXH.data.HoSo !== null
                            ? contactBHXH.data.HoSo.map((item, key) => {
                                return (
                                  <TableRow
                                    key={key}
                                    style={{ backgroundColor: "#ade9ff" }}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      {item.MaHoSo}
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      Hồ sơ 1: {item.TenHoSo} <br />
                                      Mã phiếu hẹn: {item.PhieuHen}
                                      <br />
                                      Trạng thái hồ sơ: {
                                        item.GhiChuTrangThai
                                      }{" "}
                                      <br />
                                      Ngày tiếp nhận:{" "}
                                      {datetimeHelper.toFormat(
                                        item.NgayTiepNhan,
                                        "YYYY-MM-DD"
                                      )}
                                      <br />
                                      Ngày hẹn trả:{" "}
                                      {datetimeHelper.toFormat(
                                        item.NgayHenTra,
                                        "YYYY-MM-DD"
                                      )}
                                      <br />
                                      Ngày xử lý xong:{" "}
                                      {datetimeHelper.toFormat(
                                        item.NgayXuLyXong,
                                        "YYYY-MM-DD"
                                      )}
                                      <br />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        paddingRight: "14px",
                                      }}>
                                      {datetimeHelper.toFormat(
                                        item.CreatedDate,
                                        "YYYY-MM-DD"
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            : ""
                          : ""}
                      </TableBody>
                    </Table>
                  </Grid>
                </MuiPickersUtilsProvider>
              </ValidatorForm>
            }
            otherButton={
              <React.Fragment>
                <DialogActions>
                  <Button
                    onClick={() => this.setState({ optionView: false })}
                    color="secondary"
                    className={classes.button}>
                    Trở lại
                  </Button>
                </DialogActions>
              </React.Fragment>
            }
          />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            // open={true}
            open={!!this.props.listActiveCall[0]}
            onExited={() => {
              this.setState({ note: null, addNote: false, from: null });
            }}
            // onClose={() => this.history.push(`${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`)}
            ContentProps={{
              "aria-describedby": "message-id",
              className: classes.snackbar,
            }}
            message={
              !this.props.listActiveCall[0] ? (
                <React.Fragment></React.Fragment>
              ) : (
                <React.Fragment>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex" }}>
                      <Fab
                        aria-label="Call"
                        style={{ backgroundColor: "#43a047", color: "#fff" }}>
                        {this.props.listActiveCall[0] ? (
                          this.props.listActiveCall[0].type == "inbound" ? (
                            <Icon>phone_callback</Icon>
                          ) : (
                            <Icon>phone_forwarded</Icon>
                          )
                        ) : (
                          <React.Fragment />
                        )}
                      </Fab>
                      <Typography
                        className={classes.typo}
                        variant="h6"
                        onClick={this.handleReject}
                        style={{
                          alignItems: "center",
                          display: "flex",
                          marginLeft: "15px",
                        }}>
                        <span style={{ color: "red" }}>
                          {this.props.listActiveCall[0].type === "inbound"
                            ? this.props.listActiveCall[0].to
                            : this.props.listActiveCall[0].from}{" "}
                        </span>
                        <IconButton
                          aria-owns={"material-appbar"}
                          aria-haspopup="true"
                          onClick={() => {
                            this.setState({
                              activeCallNoti: !this.state.activeCallNoti,
                            });
                          }}
                          color="inherit">
                          <Icon>info</Icon>
                        </IconButton>
                      </Typography>
                    </div>
                    <div
                      style={{
                        marginLeft: 10,
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}>
                      <Typography className={classes.typo}>
                        <b>Loại:</b>{" "}
                        {this.props.listActiveCall[0].type === "inbound"
                          ? "Gọi vào"
                          : "Gọi ra"}
                      </Typography>
                      <Typography className={classes.typo}>
                        <b>SĐT khách hàng:</b>{" "}
                        {this.props.listActiveCall[0].type === "inbound"
                          ? this.props.listActiveCall[0].from
                          : this.props.listActiveCall[0].to}
                      </Typography>
                      <Typography className={classes.typo}>
                        <b>Trạng thái:</b> {this.props.listActiveCall[0].status}
                      </Typography>
                      {this.props.loadingInfoPhone ? (
                        <CircularProgress />
                      ) : (
                        <>
                          <Typography className={classes.typo}>
                            <b>Họ tên:</b> {this.props.infoPhone?.name}
                          </Typography>
                          <Typography className={classes.typo}>
                            <b>Email:</b> {this.props.infoPhone?.email}
                          </Typography>
                          <Typography className={classes.typo}>
                            <b>Địa chỉ liên hệ:</b>{" "}
                            {this.props.infoPhone?.address}
                          </Typography>
                          <Typography className={classes.typo}>
                            <b>Thời gian gọi:</b>{" "}
                            {datetimeHelper.secondToHHMMSS(
                              this.props.listActiveCall[0].bridgedDuration
                            )}
                          </Typography>
                        </>
                      )}
                      {/* <Typography className={classes.typo}>
                                                    Thời gian: {this.state.statusAnswer.answeredDuration ? datetimeHelper.secondToHHMMSS(this.state.statusAnswer.answeredDuration) : "00:00:00"}
                                                </Typography> */}
                    </div>
                  </div>
                  {this.props.listActiveCall[0]?.status === "answering" ? (
                    <>
                      <div style={{ marginTop: 5, marginBottom: 5 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={() =>
                            this.setState({ addNote: !this.state.addNote })
                          }>
                          Ghi chú
                        </Button>
                      </div>
                      {this.state.addNote == true ? (
                        <ValidatorForm
                          ref="form"
                          onSubmit={this.handleAddNote}
                          onError={(errors) => console.log(errors)}
                          className={classes.form}>
                          <div
                            style={{ alignItems: "center", display: "flex" }}>
                            <TextValidator
                              id="outlined-full-width"
                              margin="normal"
                              label="Ghi chú cuộc gọi"
                              variant="outlined"
                              // className={classes.input}
                              // style={{ backgroundColor: '#fff' }}
                              style={{ marginRight: 5 }}
                              onChange={this.handleChange("note")}
                              value={note}
                              name="note"
                              multiline
                              validators={["required"]}
                              errorMessages={[`Không được để trống`]}
                            />
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              type="submit">
                              <Icon>add</Icon>
                            </Button>
                          </div>
                        </ValidatorForm>
                      ) : (
                        <React.Fragment />
                      )}
                    </>
                  ) : null}
                </React.Fragment>
              )
            }
            // action={
            // <IconButton
            //     aria-owns={true ? 'material-appbar' : null}
            //     aria-haspopup="true"
            //     onClick={() => this.history.push(`${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`)}
            //     color="inherit"
            // >
            //     <Icon>info</Icon>
            // </IconButton>
            // }
          />
          <Snackbar
            open={this.props.openReload}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            ContentProps={{
              "aria-describedby": "message-id",
              className: classes.snackbarReload,
            }}
            message={"Thao tác cần reload lại trang!"}
            action={
              <IconButton
                aria-owns={"material-appbar"}
                aria-haspopup="true"
                onClick={() => window.location.reload()}
                color="inherit">
                <Icon>cached</Icon>
              </IconButton>
            }
          />
          <Snackbar
            open={this.state.openSocketMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={() => this.setState({ openSocketMessage: false })}>
            <SnackbarContent
              style={{ backgroundColor: "#1890ff" }}
              message={
                <>
                  <InfoOutlinedIcon /> <span>{this.state.socketMessage}</span>
                </>
              }
              classes={{
                message: "muiSnackbar--Message",
                action: "muiSnackbar--Action",
              }}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={() => this.setState({ openSocketMessage: false })}>
                  <CloseIcon />
                </IconButton>,
              ]}
            />
          </Snackbar>
          <Snackbar
            open={this.state.openLogoutMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={() => this.setState({ openLogoutMessage: false })}
            autoHideDuration={5000}>
            <SnackbarContent
              style={{ backgroundColor: "#ff4d4f" }}
              message={
                <>
                  <ErrorOutlined /> <span>{this.state.logoutMessage}</span>
                </>
              }
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={() => this.setState({ openLogoutMessage: false })}>
                  <CloseIcon />
                </IconButton>,
              ]}
            />
          </Snackbar>
        </main>
      </div>
    );
  }
}

MiniDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  name: PropTypes.string,
};

const mapStateToProps = (state) => ({
  menu: state.auth.init,
  agentStatus: state.agent.status,
  newUpdateAgent: state.agent.newUpdateAgent,
  openReload: state.agent.openReload,
  info: state.user.info,
  user: state.auth.init,
  listStatus: state.agentStatus.agentStatus,
  article: state.article.article,
  listSearchArticle: state.article.newArticle,
  listTopic: state.topic.tree,
  listInteractiveLogs: state.call.logs,
  modalCall: state.webrtc.modal,
  callSession: state.webrtc.callSession,
  // listExtension: state.extension.extensions,
  loadingLog: state.call.loadingLog,
  infoCustomer: state.call.infoCustomer,
  logInboundOutbound: state.call.logInboundOutbound,
  callInfo: state.call.callInfo,
  listActiveCall: state.channel.activeCall,
  contactBHXH: state.call.contactBHXH,
  articles: state.call.articles,
  pauseAgent: state.call.pauseAgent,
  infoPhone: state.call.infoPhone,
  loadingInfoPhone: state.call.loadingInfoPhone,
});

MiniDrawer = connect(mapStateToProps, mapActionsToProps)(MiniDrawer);
const Agent = connect(null, actionAgent)(MiniDrawer);
const AgentStatus = connect(null, actionStatus)(Agent);
const TopicMap = connect(null, topicAction)(AgentStatus);
const Article = connect(null, articelAction)(TopicMap);
const CallLogs = connect(null, callLogsAction)(Article);
const WebrtcAction = connect(null, webrtcAction)(CallLogs);
const ExtensionAction = connect(null, extensionAction)(WebrtcAction);
const Channel = connect(null, ChannelAction)(ExtensionAction);
MiniDrawer = withRouter(Channel);

export default withWidth()(withStyles(styles, { withTheme: true })(MiniDrawer));
